/**
 * Error-related constants
 */

// Axios network error codes
export const NETWORK_ERROR_CODES = [
  'ERR_NETWORK',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_INTERNET_DISCONNECTED'
] as const;

// Network error message patterns (case-insensitive matching)
export const NETWORK_ERROR_MESSAGE_PATTERNS = [
  'ERR_INTERNET_DISCONNECTED',
  'ERR_NETWORK',
  'NET::ERR_INTERNET_DISCONNECTED',
  'NET::ERR_NETWORK_CHANGED',
  'FAILED TO FETCH'
] as const;
